import { Link } from "react-router-dom";
import { featuredComic } from "@/mocks/comics";

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20artistic%20illustration%20of%20a%20massive%20orange%20flame%20bursting%20against%20a%20dark%20manga%20city%20skyline%20at%20dusk%2C%20floating%20ember%20particles%20and%20sparks%2C%20dramatic%20shonen%20anime%20atmosphere%2C%20strong%20contrast%20between%20bright%20warm%20flame%20and%20deep%20shadow%20buildings%2C%20abstract%20artistic%20composition%2C%20cinematic%20wide%20shot%2C%20no%20text%20no%20people&width=1600&height=900&seq=hero-178mh&orientation=landscape"
          alt="家庭教师漫画火焰主题背景"
          title="《家庭教师》漫画在线免费阅读-178漫画网"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      <div className="relative z-10 mx-auto w-full px-4 py-20 md:px-6 lg:px-10">
        <div className="mx-auto flex w-full max-w-4xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm">
            <i className="ri-fire-fill text-accent-400" aria-hidden="true" />
            全网独家 · 下拉式漫画阅读
          </span>

          <h2 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
            《家庭教师》<br className="md:hidden" /> 在线免费阅读
          </h2>

          <p className="mt-5 max-w-2xl text-sm leading-7 text-background-50/90 md:text-base md:leading-8">
            通过178漫画网在线免费阅读《家庭教师》下拉式漫画，便捷的浏览方式解放您的双手。
            死气之炎觉醒，彭格列十代目的传说就此开始，海量章节持续更新，畅享高清阅读体验。
          </p>

          <div className="mt-8 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
            <Link
              to={`/manga/${featuredComic.id}`}
              className="flex h-12 w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 text-sm font-bold text-background-50 transition-all hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-book-open-line" aria-hidden="true" />
              立即开始阅读
            </Link>
            <Link
              to="/category/all"
              className="flex h-12 w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-8 text-sm font-bold text-background-50 backdrop-blur-sm transition-all hover:bg-background-50/20 sm:w-auto"
            >
              <i className="ri-grid-fill" aria-hidden="true" />
              浏览全部漫画
            </Link>
          </div>

          <div className="mt-10 flex w-full flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {[
              { value: "5000+", label: "部漫画资源" },
              { value: "3.2亿", label: "累计阅读人气" },
              { value: "24h", label: "每日持续更新" },
              { value: "100%", label: "免费阅读" },
            ].map((s) => (
              <div key={s.label} className="flex flex-col items-center gap-1">
                <span className="font-heading text-2xl font-black text-accent-400 md:text-3xl">{s.value}</span>
                <span className="text-xs text-background-50/80">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}